const defaultSelected = {
  name: '',
  uri: '',
  textButton: '',
  hrefButton: null,
  id: 0,
  callback: () => {},
};

export default {
  namespaced: true,
  state: {
    selected: {
      ...defaultSelected,
    },
    personas: [
      {
        id: 1,
        name: 'Peq. Empresa',
        uri: '/empreendedores',
        textButton: 'COMPRE ONLINE',
        hrefButton: '/nossos-precos',
        eventAnalytics: 'nossos-precos',
      },
      {
        id: 2,
        name: 'Gde. Empresa',
        uri: '/corporacoes',
        textButton: 'COMPRE ONLINE',
        hrefButton: '/nossos-precos',
        eventAnalytics: 'fale-com-especialista',
      },
      {
        id: 3,
        name: 'Associação',
        uri: '/associacoes',
        textButton: 'COMPRE ONLINE',
        hrefButton: '/nossos-precos',
        eventAnalytics: 'procure-pelo-sorriso',
      },
      {
        id: 4,
        name: 'Operador',
        uri: '/centrais-de-triagem',
        textButton: 'COMPRE ONLINE',
        hrefButton: '/nossos-precos',
        eventAnalytics: 'quero-ser-operador',
      },
      {
        id: 5,
        name: 'Consumidor',
        uri: '/consumidores',
        textButton: 'COMPRE ONLINE',
        hrefButton: '/nossos-precos',
        eventAnalytics: 'aderir-ao-sistema',
      },
    ],
  },
  mutations: {
    updateSelected(state, newPersona) {
      state.selected = { ...defaultSelected, ...newPersona };
    },
  },
};
